import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
// import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PagoMovilFormComponent } from './pago-movil-form.component';

@NgModule({
    declarations: [PagoMovilFormComponent],
    exports: [PagoMovilFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        // NgxMatIntlTelInputModule,
        FlexModule
    ]
})
export class PagoMovilFormModule {}
